import axiosInstance from "./axiosInstance";

const ProjectService = {
    getProjects: async (page, rowsPerPage) => {
            const response = await axiosInstance.get("/api/projects?page=" + page + "&size=" + rowsPerPage);
            return response.data; // Assume the API returns customer data
    },
    createProject: async (newProject) => {
            console.log(newProject)
            const response = await axiosInstance.post("/api/projects", newProject);
            return response.data; // Returns the created customer data
    },

    getProject: async (entryPage, entrySize, id) => {
            const response = await axiosInstance.get("/api/projects/" + id + "?page=" + entryPage +"&size=" + entrySize);
            return response.data; // Returns the created customer data
    },

    createProjectEntry: async (projectEntry) => {
            const response = await axiosInstance.post("/api/project-entries", projectEntry);
            return response.data; // Returns the created customer data
    },

    updateProjectEntry: async (id, projectEntry) => {
            const response = await axiosInstance.put("/api/project-entries/" + id, projectEntry);
            return response.data; // Returns the created customer data
    },

    deleteProjectEntry: async (id) => {
            const response = await axiosInstance.delete("/api/project-entries/" + id);
            return response.data;
    },

    getTimeTrackingEntries: async (start, end, userId) => {
        const params = new URLSearchParams({ start, end });
        if (userId != null) params.append('userId', userId);
        const response = await axiosInstance.get(`/api/project-entries/time-tracking?${params}`);
        return response.data;
    },

    getAllProjectsFlat: async () => {
        const response = await axiosInstance.get('/api/projects?page=0&size=200');
        return response.data?.content || [];
    },

    updateProject: async (id, editedProject) =>{

            const response = await axiosInstance.put("/api/projects/" + id, editedProject);
            return response.data; // Returns the created customer data

    },
    deleteProject: async (id) => {
            const response = await axiosInstance.delete("/api/projects/" + id);
            return response.data; // Returns the created customer data
    },
    downloadReport: async (reportId) => {
        const response = await axiosInstance.get("/api/reports/" + reportId + "/pdf");
        return response.data;
    },

    downloadPdfReport: async (reportId) => {
        const response = await axiosInstance.get("/api/reports/" + reportId + "/download", { responseType: 'blob' });
        return response.data;
    },

    createOrUpdateReport: async (projectId, dto) => {
        const response = await axiosInstance.put("/api/reports/project/" + projectId, dto);
        return response.data;
    },

    generateReport: async (projectId, reportData) => {
        const response = await axiosInstance.put("/api/reports/project/" + projectId, reportData);
        return response.data;
    },

    getReport: async (reportId) => {
        const response = await axiosInstance.get("/api/reports/" + reportId);
        return response.data;
    },

    getReportImages: async (reportId) => {
        const response = await axiosInstance.get("/api/reports/" + reportId + "/images");
        return response.data;
    },

    uploadReportImage: async (reportId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post("/api/reports/" + reportId + "/images", formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    deleteReportImage: async (reportId, imageId) => {
        const response = await axiosInstance.delete("/api/reports/" + reportId + "/images/" + imageId);
        return response.data;
    },

    reorderReportImages: async (reportId, orderedIds) => {
        const response = await axiosInstance.patch("/api/reports/" + reportId + "/images/order", { orderedIds });
        return response.data;
    },

    updateReportImageCaption: async (reportId, imageId, caption) => {
        const response = await axiosInstance.patch("/api/reports/" + reportId + "/images/" + imageId + "/caption", { caption });
        return response.data;
    },

    signReport: async (reportId, dto) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/sign", dto);
        return response.data;
    },

    refuseReport: async (reportId, dto) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/refuse", dto);
        return response.data;
    },

    markReportCustomerNotAvailable: async (reportId) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/mark-customer-not-available");
        return response.data;
    },

    sendReportForRemoteSignature: async (reportId, dto) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/send-for-remote-signature", dto);
        return response.data;
    },

    confirmReportWithoutSignature: async (reportId, dto) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/confirm-without-signature", dto);
        return response.data;
    },

    reopenReport: async (reportId) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/reopen");
        return response.data;
    },

    publishReport: async (reportId) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/publish");
        return response.data;
    },
    publishReportToPortal: async (reportId) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/publish-portal");
        return response.data;
    },
    unpublishReportFromPortal: async (reportId) => {
        const response = await axiosInstance.post("/api/reports/" + reportId + "/unpublish-portal");
        return response.data;
    },

    deleteReport: async (reportId) => {
        const response = await axiosInstance.delete("/api/reports/" + reportId);
        return response.data;
    },

    sendReportEmail: async (reportId, dto) => {
        const response = await axiosInstance.post(`/api/reports/${reportId}/send-email`, dto);
        return response.data;
    },
    generateInvoice: async(projectId, invoice)  => {
            const response = await axiosInstance.post("/api/invoices/"+projectId, invoice);
            return response.data; // Returns the created customer data
    },

    getInvoice: async (invoiceId) => {
        const response = await axiosInstance.get("/api/invoices/" + invoiceId);
        return response.data;
    },

    downloadInvoice: async (invoiceId) => {
            const response = await axiosInstance.get("/api/invoices/" + invoiceId + "/pdf");
            return response.data; // Returns the created customer data

    },

    shareInvoice: async (invoiceId) => {
        const response = await axiosInstance.post("/api/invoices/" + invoiceId + "/share");
        return response.data; // Returns the created customer data

    },

    updateInvoice: async(invoice)  => {
        const response = await axiosInstance.put("/api/invoices/" + invoice.id, {status: invoice.status});
        return response.data; // Returns the created customer data
    },

    deleteInvoice: async(invoiceId)  => {
            const response = await axiosInstance.delete("/api/invoices/" + invoiceId);
            return response.data; // Returns the created customer data
    },


    countAllProjects: async() => {
        const response = await axiosInstance.get("/api/projects/count");
        return response.data;
    },

    getAllPendingProjects: async() => {
        const response = await axiosInstance.get("/api/projects/getPendingProjects");
        return response.data;
    },

    getTop5ByRevenue: async() => {
        const response = await axiosInstance.get("/api/projects/getTop5ByRevenue");
        return response.data;
    },

    getMonthlyRevenue: async() => {
        const response = await axiosInstance.get("/api/invoices/getMonthlyRevenue");
        return response.data;
    },

    getYearlyRevenue: async() => {
        const response = await axiosInstance.get("/api/invoices/getYearlyRevenue");
        return response.data;
    },

    getInvoiceCounts: async() => {
        const response = await axiosInstance.get("/api/invoices/count");
        return response.data;
    },

    getRevenueGrowth: async() => {
        const response = await axiosInstance.get("/api/invoices/getRevenueGrowth");
        return response.data;
    },

    // In /src/services/ProjectService.js

    createProjectExpense: async (projectExpense) => {
        const response = await axiosInstance.post("/api/project-expenses", projectExpense);
        return response.data;
    },

    updateProjectExpense: async (id, projectExpense) => {
        const response = await axiosInstance.put(`/api/project-expenses/${id}`, projectExpense);
        return response.data;
    },

    deleteProjectExpense: async (id) => {
        const response = await axiosInstance.delete(`/api/project-expenses/${id}`);
        return response.data;
    },

    getProjectSubServices: async (projectId, page, size) => {
        const response = await axiosInstance.get(`/api/projects/${projectId}/sub-services`, {
            params: { page, size },
        });
        return response.data;
    },

    addProjectSubService: async (projectId, dto) => {
        const response = await axiosInstance.post(`/api/projects/${projectId}/sub-services`, dto);
        return response.data;
    },

    updateProjectSubService: async (projectId, pssId, dto) => {
        const response = await axiosInstance.put(`/api/projects/${projectId}/sub-services/${pssId}`, dto);
        return response.data;
    },

    deleteProjectSubService: async (projectId, pssId) => {
        const response = await axiosInstance.delete(`/api/projects/${projectId}/sub-services/${pssId}`);
        return response.data;
    },

    getInventoryUsageByProject: async (projectId) => {
        const response = await axiosInstance.get(`/api/projects/${projectId}/inventory-usage`);
        return response.data;
    },

    addInventoryUsage: async (projectId, dto) => {
        const response = await axiosInstance.post(`/api/projects/${projectId}/inventory-usage`, dto);
        return response.data;
    },

    deleteInventoryUsage: async (projectId, usageId) => {
        await axiosInstance.delete(`/api/projects/${projectId}/inventory-usage/${usageId}`);
    },

    createInvoice: async(formData) => {
        const response = await axiosInstance.post("/api/invoices", formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    getInvoicePayments: async(invoiceId) => {
        const response = await axiosInstance.get(`/api/invoices/${invoiceId}/payments`);
        return response.data;
    },

    recordInvoicePayment: async(invoiceId, requestData) => {
        const response = await axiosInstance.post(`/api/invoices/${invoiceId}/payments`, requestData);
        return response.data;
    },

    deleteInvoicePayment: async(invoiceId, paymentId) => {
        return await axiosInstance.delete(`/api/invoices/${invoiceId}/payments/${paymentId}`);
    },

    getInvoiceCreditNotes: async(invoiceId) => {
        const response = await axiosInstance.get(`/api/invoices/${invoiceId}/credit-notes`);
        return response.data;
    },

    createCreditNote: async(invoiceId, requestData) => {
        const response = await axiosInstance.post(`/api/invoices/${invoiceId}/credit-notes`, requestData);
        return response.data;
    },

    issueCreditNote: async(creditNoteId) => {
        const response = await axiosInstance.post(`/api/invoices/credit-notes/${creditNoteId}/issue`);
        return response.data;
    },

    downloadCreditNotePdf: async(creditNoteId) => {
        return await axiosInstance.get(`/api/invoices/credit-notes/${creditNoteId}/pdf`, { responseType: 'blob' });
    },

    createPartialInvoice: async(requestData) => {
        const response  = await axiosInstance.post("/api/invoices/partial", requestData);
        return  response.data
    },

    createFinalInvoice: async(requestData) => {
        const response  = await axiosInstance.post("/api/invoices/final", requestData);
        return  response.data
    },

    createFixedInvoice: async(requestData) => {
        const response = await axiosInstance.post("/api/invoices/fixed", requestData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data
    },

    previewPartialInvoice: async(requestData) => {
        const response = await axiosInstance.post("/api/invoices/partial/preview", requestData);
        return response.data
    },

    previewFixedInvoice: async(requestData) => {
        const response = await axiosInstance.post("/api/invoices/fixed/preview", requestData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data
    },

    downloadPdfInvoice: async(invoiceId) => {
        return  await axiosInstance.get(`/api/invoices/${invoiceId}/download`, {responseType: "blob"})
    },

    downloadPdfReport: async(reportEntry) => {
        return  await axiosInstance.get(`/api/reports/${reportEntry}/download`, {responseType: "blob"})
    },

    cancelInvoice: async(invoiceId, requestData) => {
        return  await axiosInstance.post(`/api/invoices/${invoiceId}/cancel`, requestData)
    },

    markInvoiceAsSent: async(invoiceId) => {
        return await axiosInstance.post(`/api/invoices/${invoiceId}/mark-sent`);
    },

    writeOffInvoice: async(invoiceId, requestData) => {
        return await axiosInstance.post(`/api/invoices/${invoiceId}/write-off`, requestData);
    },

    issueInvoice: async(invoiceId) => {
        return await axiosInstance.post(`/api/invoices/${invoiceId}/issue`);
    },

    searchProjects: async(requestData) => {
        return  await axiosInstance.post(`/api/projects/search`, requestData)
    },

    sendEmailInvoice: async(id, requestData) => {
        return  await axiosInstance.post(`/api/invoices/${id}/email`, requestData)
    },

    getProjectInfo: async(projectId) => {
        const response = await axiosInstance.get(`/api/projects/${projectId}/info`);
        return response.data;
    },

    publishInvoiceToPortal: (id) => axiosInstance.post(`/api/invoices/${id}/publish-portal`).then(r => r.data),

    unpublishInvoiceFromPortal: (id) => axiosInstance.post(`/api/invoices/${id}/unpublish-portal`).then(r => r.data),

    // ─── Project Notes (CRM side) ─────────────────────────────────────────────
    getProjectEntriesFiltered: async (projectId, filters = {}, page = 0, size = 10) => {
        const params = new URLSearchParams({ page, size });
        if (filters.userId != null)    params.append('userId',    filters.userId);
        if (filters.startDate != null) params.append('startDate', filters.startDate);
        if (filters.endDate   != null) params.append('endDate',   filters.endDate);
        if (filters.invoiced  != null) params.append('invoiced',  filters.invoiced);
        const response = await axiosInstance.get(`/api/project-entries/by-project/${projectId}/filtered?${params}`);
        return response.data;
    },

    getNotes: (id) => axiosInstance.get(`/api/projects/${id}/notes`).then(r => r.data),

    addNote: (id, data) => axiosInstance.post(`/api/projects/${id}/notes`, data).then(r => r.data),

    editNote: (id, noteId, data) => axiosInstance.put(`/api/projects/${id}/notes/${noteId}`, data).then(r => r.data),

    deleteNote: (id, noteId) => axiosInstance.delete(`/api/projects/${id}/notes/${noteId}`).then(r => r.data),
};

export default ProjectService;
